import { useContext } from 'react';
import { createHOCWithHookInside } from '../../hoc/createHOCWithHookInside';
import { FilesUploaderContext } from './FilesUploaderProvider';
import { IFilesUploaderContext } from './types';

export const useImportOperations = () => {
  const { importOperations } = useContext(FilesUploaderContext);

  return { importOperations };
};

export const useUploadQueueHandlers = () => {
  const { cancelAllUploads, clearUploadingQueue, removeFileFromUploadingQueue } = useContext(FilesUploaderContext);

  return { cancelAllUploads, clearUploadingQueue, removeFileFromUploadingQueue };
};

export const useUploadQueueObservables = (): Pick<
  IFilesUploaderContext,
  | 'queueStartObservable'
  | 'queueChangeObservable'
  | 'queueFinishedObservable'
  | 'itemUploadedObservable'
  | 'folderUploadedObservable'
> => {
  const {
    queueStartObservable,
    queueChangeObservable,
    queueFinishedObservable,
    itemUploadedObservable,
    folderUploadedObservable,
  } = useContext(FilesUploaderContext);

  return {
    queueStartObservable,
    queueChangeObservable,
    queueFinishedObservable,
    itemUploadedObservable,
    folderUploadedObservable,
  };
};

/**
 * @deprecated use "useUploadQueueObservables"
 */
export const withUploadQueueObservables = createHOCWithHookInside(
  'WithUploadQueueObservables',
  useUploadQueueObservables,
);
